import React, { useState, useEffect } from 'react';
import './Promo.css';
import { Link } from 'react-scroll';
import globe from '../../../images/globe.svg';

const phrases = [
  'Welcome!',
  'here, beautiful people',
  'find their beautiful photos'
];

export default function Promo() {
  const [typedLines, setTypedLines] = useState(Array(phrases.length).fill(''));
  const [currentLine, setCurrentLine] = useState(0);
  const [currentChar, setCurrentChar] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (!isTyping) return;

    if (currentLine >= phrases.length) {
      setIsTyping(false);
      return;
    }

    const delay = Math.floor(Math.random() * 200) + 50;
    const line = phrases[currentLine];

    if (currentChar < line.length) {
      const timeout = setTimeout(() => {
        setTypedLines((lines) => {
          const nextLines = [...lines];
          nextLines[currentLine] = line.slice(0, currentChar + 1);
          return nextLines;
        });
        setCurrentChar((char) => char + 1);
      }, delay);

      return () => clearTimeout(timeout);
    } else {
      const nextLineTimeout = setTimeout(() => {
        setCurrentLine((lineIndex) => lineIndex + 1);
        setCurrentChar(0);
      }, 400);

      return () => clearTimeout(nextLineTimeout);
    }
  }, [currentChar, currentLine, isTyping]);

  return (
    <section className='promo'>
      <div className='promo__container'>
        <div className='promo__container_background'></div>
        <div className='promo__container-intro'>
          <h1 className='promo__title'>
            {phrases.map((_, index) => (
              <div key={index} className="typed-line">
                <span className="typed-text">
                  {typedLines[index].split('').map((char, i) => (
                    <span key={i} className="fade-letter" style={{ animationDelay: `${0.03}s` }}>
                      {char}
                    </span>
                  ))}
                </span>

                {isTyping && index === currentLine && <span className="cursor">|</span>}
              </div>
            ))}
          </h1>
          <p className='promo__subtitle'>Scroll down to learn about this Website and its creator</p>
          <Link className='promo__link' to='about' duration={500} smooth={true}>Learn More</Link>
        </div>
        <img className='promo__globe' src={globe} alt='Globe' />
      </div>
    </section>
  );
}
